import { render, staticRenderFns } from "./rightNav.vue?vue&type=template&id=3831ef2a&scoped=true"
import script from "./rightNav.vue?vue&type=script&lang=js"
export * from "./rightNav.vue?vue&type=script&lang=js"
import style0 from "./rightNav.vue?vue&type=style&index=0&id=3831ef2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831ef2a",
  null
  
)

export default component.exports